import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const OnlineCourse = () => {
 
     useEffect(() => {
         if (typeof window !== 'undefined') {
             const AOS = require('aos');
             AOS.init({
                 duration: 1000,
                 once: true
             });
         }
     }, []);

  return (
    <section className="mb-3 mb-md-5">
      <div className="container bg-french">
        <div className="row">
          <h2
            className="sec-title text-center"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            ABOUT THE ONLINE COURSE
          </h2>
        </div>

        <div className="row p-3 d-flex justify-content-center align-items-center">
          <div className="col-md-6">
            <div className="row ">
              <h2
                className="mb-3 mt-3"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                OBJECTIVES
              </h2>
            </div>

            <div className="row" data-aos="fade-up" data-aos-duration="1000">
              <p>
                After 120 hours of class, i.e. 2 semesters, the participants will
                achieve the A1 level of Common European Framework for Languages and
                will be able to:
              </p>
              <ul className="list-unstyled p-3">
                <li
                  className="mb-3"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                >
                  <i className="fa fa-check-circle-o me-2"></i>
                  Understand and use familiar everyday expressions and very basic
                  phrases aimed at the satisfaction of needs of a concrete type.
                </li>
                <li
                  className="mb-3"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-delay="100"
                >
                  <i className="fa fa-check-circle-o me-2"></i>
                  Introduce him/herself and others and can ask and answer
                  questions about personal details such as where he/she lives,
                  people he/she knows and things he/she has.
                </li>
                <li
                  className="mb-3"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-delay="200"
                >
                  <i className="fa fa-check-circle-o me-2"></i>
                  Interact in a simple way provided the other person talks slowly
                  and clearly and is prepared to help.
                </li>
                <li
                  className="mb-3"
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-delay="300"
                >
                  <i className="fa fa-check-circle-o me-2"></i>
                  A successful completion will result in A1 level certification.
                </li>
              </ul>
            </div>
          </div>

          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <div
              className="modern-card d-flex align-items-center p-4"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <div>
                <div className="row">
                  <div className="col-12 d-flex align-items-center justify-content-center gap-2">
                    <div className="icon-circle me-2">
                      <i className="fa fa-inr"></i>
                    </div>
                    <h4 className="modern-card-title mb-0">Financial Terms</h4>
                  </div>

                </div>

                <p className="modern-card-text mb-0">
                  The cost incurred under this course will be fully funded by the
                  University, except the expenses incurred on procuring the set of
                  books required for the completion of the course (which
                  approximately comes to around <strong>Rs. 850/-</strong> ).
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OnlineCourse;